import { useContext, useEffect, useState } from "react";
import NavigationBar from "../../../navigation_components/NavigationBar";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Invoices/Invoices.css";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";
import { AppContext } from "../../../AppProvider";
import NewInvoice from "./NewInvoice";
import DeleteInvoice from "./DeleteInvoice";
import { InvoiceContext } from "./InvoiceProvider";
import Invoice from "./Invoice/Invoice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import CancelInvoice from "./CancelInvoice";

const InvoicesTable = ({invoices}) =>{
    const {setSelectedInvoiceSummary,setSelectedToDeleteInvoice,setSelectedToCancelInvoice} = useContext(InvoiceContext);
    const statusColors = {
        CREATED: "gray",
        ISSUED: "darkorange",
        PAID: "green"
    };
    return(
        <table>
            <thead>
                <tr id="tenant-administrator-invoices-table-header-row">
                    <th>Created Time</th>
                    <th>Due Time</th>
                    <th>Invoice Number</th>
                    <th>Customer Name</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {invoices.map((invoice) =>(
                    <tr key={invoice?.id} onClick={() => setSelectedInvoiceSummary(invoice)}>
                        <td>{invoice?.createDate} {invoice?.createTime}</td>
                        <td>{invoice?.dueDate} {invoice?.dueTime}</td>
                        <td>{invoice?.invoiceNumber}</td>
                        <td>{invoice?.customerName}</td>
                        <td style={{color:statusColors[invoice?.status] || 'black'}}>
                            {invoice?.status? `${invoice.status.charAt(0)}${invoice.status.slice(1).toLowerCase()}`:''}
                        </td>
                        <td>
                            {invoice?.status === 'CREATED'?
                                (
                                    <img
                                        title="Delete invoice"
                                        src={`${process.env.PUBLIC_URL}/images/trash-can-icon.png`}
                                        onClick={(e) =>{
                                            e.stopPropagation();
                                            setSelectedToDeleteInvoice(invoice);
                                        }}
                                    />
                                ):invoice?.status === 'ISSUED'?
                                (
                                    <img
                                        title="Cancel invoice"
                                        src={`${process.env.PUBLIC_URL}/images/cancel-icon.png`}
                                        onClick={(e) =>{
                                            e.stopPropagation();
                                            setSelectedToCancelInvoice(invoice);
                                        }}
                                    />
                                ):invoice?.status === 'PAID'?(
                                    <img
                                        title="Print invoice"
                                        src={`${process.env.PUBLIC_URL}/images/print-icon.png`}
                                        onClick={(e) =>{
                                            e.stopPropagation();
                                            setSelectedToCancelInvoice(invoice);
                                        }}
                                    />
                                ):<></>
                            }
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
const Invoices = () =>{
    const {
        showNewInvoiceWindow,setShowNewInvoiceWindow,
        reloadInvoices,setReloadInvoices,
        setSelectedInvoiceSummary,selectedInvoiceSummary,
        selectedToDeleteInvoice,selectedToCancelInvoice
    } = useContext(InvoiceContext);
    const {user,logout} = useContext(AppContext);
    const navigate = useNavigate();
    const [invoices,setInvoices] = useState(null);
    const {invoiceIdPathVariable} = useParams();
    const [searchParams,setSearchParams] = useSearchParams();
    const create_new = searchParams.get('create_new');
    const fetchInvoices = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/invoices`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok) setInvoices(await response.json());
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when fetching invoices from the server',error);
        }
    };
    useEffect(() =>{
        fetchInvoices();
    },[]);
    useEffect(() =>{
        if(!reloadInvoices) return;
        const refetchInvoices = async() =>{
            await fetchInvoices();
            setReloadInvoices(false);
        };
        refetchInvoices();
    },[reloadInvoices]);
    useEffect(() =>{
        if(create_new && invoices != null) setShowNewInvoiceWindow(true);
    },[create_new,invoices]);
    useEffect(() =>{
        if(showNewInvoiceWindow && create_new){
            const newParams = new URLSearchParams(searchParams);
            newParams.delete('create_new');
            setSearchParams(newParams);
        }
    },[showNewInvoiceWindow,create_new]);
    useEffect(() =>{
        if(!invoiceIdPathVariable || !Array.isArray(invoices)) return;
        setSelectedInvoiceSummary(invoices.find(invoice => invoice?.id === invoiceIdPathVariable));
        navigate('/tenants/invoices',{replace:true});
    },[invoiceIdPathVariable,invoices]);
    return(
        <div className="tenant-administrator-invoices-page">
            <NavigationBar/>
            <div className="tenant-administrator-invoices-page-layout">
                <TenantAdministratorSideBar/>
                <div className="tenant-administrator-invoices-parent-container">
                    {!invoices && !showNewInvoiceWindow && !selectedToDeleteInvoice && !selectedToCancelInvoice?
                    (
                        <div className="tenant-administrator-invoices-container">
                            <div className="tenant-administrator-invoices-header">
                                <h2>Invoices</h2>
                            </div>
                            <div className="tenant-administrator-loading-invoices-parent-container">
                                <div className="tenant-administrator-loading-invoices-container">
                                    <div></div>
                                    <p>Loading invoices. Please wait...</p>
                                </div>
                            </div>
                        </div>
                    ):reloadInvoices && !showNewInvoiceWindow && !selectedToDeleteInvoice && !selectedToCancelInvoice && !selectedInvoiceSummary?
                    (
                        <div className="tenant-administrator-invoices-container">
                            <div className="tenant-administrator-invoices-header">
                                <h2>Invoices</h2>
                            </div>
                            <div className="tenant-administrator-reloading-invoices-parent-container">
                                <div className="tenant-administrator-reloading-invoices-container">
                                    <div></div>
                                    <p>Reloading invoices. Please wait...</p>
                                </div>
                            </div>
                        </div>
                    ):invoices.length === 0?
                    (
                        <div className="tenant-administrator-invoices-unavailable-container"
                            style={{display:showNewInvoiceWindow || selectedToDeleteInvoice? 'none':'block'}}>
                            <h2>No invoices available</h2>
                            <p>There are currently no invoices to display.</p>
                            <div>
                                <button onClick={() => setShowNewInvoiceWindow(true)}>Create Invoice</button>
                            </div>
                        </div>
                    ):
                    (
                        <div className="tenant-administrator-invoices-container">
                            <div className="tenant-administrator-invoices-header">
                                <h2>Invoices</h2>
                                <div className="tenant-administrator-invoices-header-controls">
                                    <button className="search-invoice-button"
                                        title="Search invoice">
                                        <img src={`${process.env.PUBLIC_URL}/images/search-icon-coloured.png`}/>
                                    </button>
                                    <button className="add-invoice-button"
                                        title="Add an invoice"
                                        onClick={() => setShowNewInvoiceWindow(true)}>
                                        <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`}/>
                                    </button>
                                </div>
                            </div>
                            <InvoicesTable
                                invoices={invoices}
                            />
                            <Invoice/>
                        </div>
                    )}
                </div>
                <NewInvoice
                    showNewInvoiceWindow={showNewInvoiceWindow}
                    setShowNewInvoiceWindow={setShowNewInvoiceWindow}
                />
                <DeleteInvoice/>
                <CancelInvoice/>
            </div>
        </div>
    );
};
export default Invoices;